import ButtonLoader from 'utils/ButtonLoader'
import { FakeSubmit } from '@gunnarssongroup/fake-submit'

const Category = {
  el: {
    root: document.querySelector<HTMLElement>('.category-overview'),
    body: document.querySelector<HTMLElement>('.body'),
    filters: document.querySelector<HTMLElement>('.category-filters'),
    category: document.querySelector<HTMLElement>('.category-overview'),
    form: document.querySelector<HTMLFormElement>('.category-filters__form'),
    searchInput: document.querySelector<HTMLInputElement>('.category-flters__search-input'),
    searchButton: document.querySelector<HTMLInputElement>('.filter-search .button'),
    fakeSelects: document.querySelectorAll<HTMLElement>('.category-filters .fake-select'),
    selects: document.querySelectorAll<HTMLElement>('.category-filters .input-group--select select'),
    sortHidden: document.querySelector<HTMLInputElement>('.category-filters [name="sort"]'),
    priceHidden: document.querySelector<HTMLInputElement>('.category-filters [name="price"]'),
    mobileCategoriesTrigger: document.querySelector<HTMLInputElement>('.category-filters__category-trigger'),
    mobileCategories: document.querySelector<HTMLInputElement>('.category-nav-mobile'),
    mobileBack: document.querySelector<HTMLInputElement>('.category-nav-mobile__back'),
  },

  init() {
    if (this.el.root) {
      this.setSubmitEvent()
      this.handleFakeSelects()
      this.handleSelects()
      this.handleOpenCategoriesMobile()
      this.handleMobileBack()
    }
  },

  setSubmitEvent() {
    this.el.form.addEventListener('submit', (e) => {
      ButtonLoader.start(this.el.searchButton)
    })
  },

  handleSelects() {
    Array.prototype.forEach.call(this.el.selects, (item: HTMLInputElement) => {
      item.addEventListener('change', (e: Event & {target: HTMLInputElement}) => {
        const parent = e.target.parentNode as HTMLElement

        if (item.value === '') {
          this.el.priceHidden.value = ''
          this.el.sortHidden.value = ''
        }
        else {
          if (parent.dataset.type === 'sort') {
            this.el.priceHidden.value = ''
            this.el.sortHidden.value = item.value
          }
  
          if (parent.dataset.type === 'price') {
            this.el.sortHidden.value = ''
            this.el.priceHidden.value = item.value
          }
        }


        FakeSubmit(this.el.form)
      })
    })
  },

  handleOpenCategoriesMobile() {
    this.el.mobileCategoriesTrigger?.addEventListener('click', () => {
      this.el.mobileCategories?.classList.add('category-nav-mobile--open')
    })
  },

  handleMobileBack() {
    this.el.mobileBack?.addEventListener('click', (e) => {
      e.preventDefault()
      this.el.mobileCategories?.classList.remove('category-nav-mobile--open')
    })
  },

  handleFakeSelects() {
    Array.prototype.forEach.call(this.el.fakeSelects, (item: HTMLElement) => {
      const trigger = item.querySelector<HTMLButtonElement>('.fake-select__trigger')
      const options = item.querySelectorAll<HTMLButtonElement>('.fake-select__option')

      trigger.addEventListener('click', (e: Event & { target: HTMLButtonElement }) => { 
        this.removeActive()

        const parent = e.target.parentNode as HTMLElement
        parent.classList.toggle('open')
      })

      Array.prototype.forEach.call(options, (option: HTMLButtonElement) => {
        option.addEventListener('click', () => {      
          const parent = option.parentNode as HTMLElement

          if (parent.dataset.type === 'sort') {
            this.el.priceHidden.value = ''
            this.el.sortHidden.value = option.dataset.value
          }

          if (parent.dataset.type === 'price') {
            this.el.sortHidden.value = ''
            this.el.priceHidden.value = option.dataset.value
          }

          FakeSubmit(this.el.form)
        })
      })
    })
  },

  removeActive(): void {
    Array.prototype.forEach.call(this.el.fakeSelects, (item: HTMLElement) => {
      item.classList.remove('open')
    })
  }
}

export default Category
